import { STATUS_LEGEND, SOURCE_LEGEND, TEMPLATES_KEYWORD } from '../../sitemap_lib';

const determineIfHasLinkedTemplate = (page) => {
  if (page.dynamic_page_template) {
    return TEMPLATES_KEYWORD;
  }

  return null;
};

const determineSource = (page) => {
  if (page.is_dynamic_page) {
    return SOURCE_LEGEND.builder.label;
  }
  if (page.parent_category_id) {
    return SOURCE_LEGEND.category.label;
  }
  if (page.is_from_sitemap) {
    return SOURCE_LEGEND.codebase.label;
  }
  if (page.is_job) {
    return SOURCE_LEGEND.job.label;
  }

  return null;
};

const determineStatus = (page) => {
  if (page.is_from_sitemap) {
    return STATUS_LEGEND.live;
  }
  if (page.is_draft) {
    return STATUS_LEGEND.draft;
  }
  return STATUS_LEGEND.pending;
};

export default function StatusBadge({ page }) {
  const status = determineStatus(page);

  const source = determineSource(page);

  const isLinkedToTemplate = determineIfHasLinkedTemplate(page);

  if (!source) {
    return <span />;
  }

  return (
    <div className={`badge ${status.backgroundColor} d-flex flex-column`}>
      <p className="mb-0 text-white">{source}</p>
      {isLinkedToTemplate ? (
        <>
          <p className="mb-0 text-white">+</p>
          <p className="mb-0 text-white">{isLinkedToTemplate}</p>
        </>
      ) : null}
    </div>
  );
}
